class AddressLookup {
  constructor(config) {
    this.config = {
      forms: document.querySelectorAll('[data-module="geolocate"]')
    };
    if (
      config &&
      typeof config === 'object' &&
      config.constructor === Object &&
      Object.getOwnPropertyNames(config).length !== 0
    ) {
      Object.keys(config).forEach(key => {
        this.config[key] = config[key];
      });
    }
  }

  init() {
    if (this.config.forms.length > 0) {
      this.config.forms.forEach(form => {
        form.addEventListener('blur', AddressLookup.resolveLocation, true);
      });
    }
  }

  static resolveLocation(event) {
    const { form } = event.target;

    if (!event.target.getAttribute('name')) {
      return;
    }

    const targetInput = event.target.getAttribute('name').toLowerCase();

    if (targetInput !== 'housenumber' && targetInput !== 'postalcode') return;

    const tempEl =
      targetInput === 'housenumber'
        ? form.elements.namedItem('postalCode')
        : form.elements.namedItem('houseNumber');

    if (!tempEl) return;

    if (event.target.value.length > 0 && tempEl.value.length > 0) {
      const cbName = `jsonp_callback_${Math.floor(10000 * Math.random())}`;
      const script = document.createElement('script');
      window[cbName] = data => {
        delete window[cbName];
        document.body.removeChild(script);
        if (data !== null && data.constructor === Object) {
          const street = form.elements.namedItem('street');
          if (street) {
            street.value = data.Street;
          }
          const city = form.elements.namedItem('city');
          if (city) {
            city.value = data.City;
          }
        }
      };
      script.src = `https://api.pangaea.nl/api/GeoEncoding?${
        targetInput === 'postalCode'
          ? `postalCode=${form.value}&houseNumber=${tempEl.value}`
          : `postalCode=${tempEl.value}&houseNumber=${form.value}`
      }&callback=${cbName}`;

      document.body.appendChild(script);
    }
  }
}

export default AddressLookup;
